var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"row justify-content-center align-items-center",staticStyle:{"height":"50vh"}},[_c('div',{staticClass:"col-4 text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/images/logo-iDEAFP.png"),"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }